import { GET_TAGS } from "constants/tags";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_TAGS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
